<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2024-05-07 10:22:51
 * @LastEditors: sjq
 * @LastEditTime: 2024-06-04 09:44:00
 -->
<template>
  <div class="address-list">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" />
    <div class="list-box" v-for="(item, index) in addressList" :key="item.id">
      <Checkbox
        v-model="item.checked"
        checked-color="#00B25A"
        v-if="isSetAddress"
        class="list-checked"
        @change="checkedChange($event, index)"
      ></Checkbox>
      <div class="list-main" @click="itemAction(item, index)">
        <div class="list-detail">
          <div class="name">{{ item.contactName }}</div>
          <div class="no">{{ item.contactNo }}</div>
          <div class="default" v-if="item.defaultMark">默认</div>
        </div>
        <div class="address">
          {{ item.mergeAreaDetail }}
        </div>
      </div>

      <Icon name="edit" class="edit-icon" @click.stop.prevent="pushAddress(item, index)" />
    </div>
    <div class="list-box push-address" v-if="isSetAddress" @click="pushAddress()">+新增地址</div>
    <form-button-buttom v-if="isSetAddress" text="保存" type="primary" size="small" @click="setAddress()" />
    <form-button-buttom v-else text="新增地址" type="primary" size="small" @click="pushAddress()" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
import { addressService, expressService, activityService } from '@/api'
import { Icon, Checkbox, Toast } from 'vant'
import { appUser } from '@/utils'

const componentName = 'AddressList'
export default {
  name: componentName,
  components: {
    Icon,
    Checkbox
  },
  mixins: [Body],
  data() {
    return {
      title: '我的地址',
      addressList: [],
      checkedIndex: null,
      type: null
    }
  },
  computed: {},
  created() {
    this.type = this.$route.query.type
    this.isSetAddress = this.type && this.type !== 'default'

    this.getList()
  },
  methods: {
    getList() {
      addressService.list().then(res => {
        if (sessionStorage.getItem('checkedAddressId')) {
          this.checkedIndex = res.findIndex(item => item.id * 1 === sessionStorage.getItem('checkedAddressId') * 1)
          this.checkedIndex = this.checkedIndex === -1 ? null : this.checkedIndex
        }
        this.addressList = res.map((item, index) => this.mergeAreaDetail(item, index))
        console.log(this.addressList, 'this.addressList')
      })
    },
    checkedChange(data, index) {
      if (data) {
        if (this.checkedIndex !== null && this.checkedIndex !== index) {
          this.addressList[this.checkedIndex].checked = false
          this.checkedIndex = index
        }
        if (this.checkedIndex === null) {
          this.checkedIndex = index
        }
      } else {
        if (this.checkedIndex === index) this.checkedIndex = null
      }
    },
    // 列表事件
    itemAction(item, index) {
      if (this.isSetAddress) {
        let checked = !this.addressList[index].checked
        this.$set(this.addressList[index], 'checked', checked)
      } else {
        let addressChecked = JSON.parse(localStorage.getItem('addressChecked')) || {}
        addressChecked[appUser.userId] = item
        localStorage.setItem('addressChecked', JSON.stringify(addressChecked))
        this.$router.back()
      }
    },
    setAddress() {
      if (this.checkedIndex === null) {
        Toast('请选择收货地址')
        return
      }
      let item = this.addressList[this.checkedIndex]
      if (this.type === 'uploadActivity') {
        activityService
          .updateAddress({
            userAddressId: item.id,
            activityId: this.$route.query.activityId,
            id: this.$route.query.id
          })
          .then(res => {
            sessionStorage.removeItem('checkedAddressId')
            this.$router.back()
          })
          .catch(err => {
            Toast(err.message || '更换失败，请联系班主任')
          })
      } else if (this.type === 'uploadExpress') {
        let params = this.$route.query
        delete params.type
        expressService
          .updateExpressAddress({
            userAddressId: item.id,
            ...params
          })
          .then(res => {
            let orderSn = this.$route.query.orderSn
            let data = JSON.parse(localStorage.getItem(orderSn))
            data.phoneNo = item.contactNo
            data.orderAddress = item.addressArea + item.addressDetail
            data.concat = item.contactName
            localStorage.setItem(orderSn, JSON.stringify(data))
            this.$router.back()
            sessionStorage.removeItem('checkedAddressId')
          })
          .catch(err => {
            Toast(err.message || '更换失败，请联系班主任')
          })
      } else {
        let addressChecked = JSON.parse(localStorage.getItem('addressChecked')) || {}
        addressChecked[appUser.userId] = item
        localStorage.setItem('addressChecked', JSON.stringify(addressChecked))
        this.$router.back()
      }
    },
    // 添加或修改地址
    pushAddress(item, index) {
      let options = {}
      this.$router.push({
        name: 'addressEdit',
        query: {
          addressId: item ? item.id : null,
          ...options
        }
      })
    },
    mergeAreaDetail(item, index) {
      let { addressArea: area, addressDetail: detail } = item
      area = area || ''
      detail = detail || ''
      const areaArr = area.split(' / ') // 省市区分隔符
      const [p, c, a] = areaArr
      area = areaArr.length > 1 ? (p === c ? p : p + c) + a : area
      item.mergeAreaDetail = area + detail
      item.checked = false
      if (this.checkedIndex !== null && this.checkedIndex === index) {
        item.checked = true
      }
      return item
    }
  }
}
</script>

<style lang="scss" scoped>
.address-list {
  margin-bottom: 100px;
  // 底部按钮
  .form-bottom-button.form-bottom-label {
    background-color: #f7f9fb;
    border-top: 1px solid #eeeeee;
  }
}

.list-box {
  display: flex;
  align-items: center;
  padding: 16px 0;
  margin: 0 16px;
  border-bottom: 1px solid #eeeeee;
  background-color: #fff;
  .list-checked {
    margin-right: 12px;
  }

  .list-main {
    flex: 1;
    color: #999;
    .list-detail {
      display: flex;
      align-items: center;
      margin-bottom: 4px;
      .name {
        font-size: 16px;
        color: #000;
        margin-right: 16px;
      }
      .no {
        margin-right: 16px;
      }
      .default {
        color: #ff7142;
        font-size: 10px;
        border: 1px solid #ff7142;
        background: rgba(255, 113, 66, 0.1);
        padding: 2px 10px;
      }
    }
  }
  .edit-icon {
    font-size: 16px;
  }
}
.push-address {
  padding: 24px 0px;
  font-size: 16px;
  font-weight: bold;
  justify-content: center;
}
</style>
